import { classnames } from '@aibees/shared/utils';
import { Button } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { DialogFooterProps as Props } from './types';

export const DialogFooter = memo(
  ({ className, closeModal, onConfirm, onCancel }: Props) => {
    const handleConfirm = () => {
      onConfirm?.();
    };

    const handleCancel = () => {
      onCancel?.();
      closeModal();
    };

    return (
      <Styled.Wrapper
        className={classnames('DialogFooter', className)}
        sx={SX.root}
      >
        <Button
          variant="text"
          color="inherit"
          onClick={handleCancel}
          size="small"
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleConfirm}
          size="small"
        >
          Continue with Downgrade
        </Button>
      </Styled.Wrapper>
    );
  }
);

DialogFooter.displayName = 'DialogFooter';
